import React from 'react';

import styled from 'styled-components';
import SEO from '../../components/seo';
import Layout from '../../components/layout';
import skills from '../../services/skills';
import Paper from './paper';
import Avatar from '../../components/avatar';
import { Title } from '../../components/typography';

const Container = styled.div`
  background-color: white;
  margin: 0 auto;
  min-height: 46rem;
  width: 100vw;
`;

const Wrapper = styled.div`
  margin: 0 auto;
  margin-top: 5rem;
  margin-bottom: 5rem;
  max-width: 80rem;
`;

const Divider = styled.div`
  background-color: #e6ecf8;
  height: 1px;
  width: 100vw;
`;
const PaperComponent = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 5px 5px 0 rgba(233, 240, 243, 0.5), 0 0 0 1px #e6ecf8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  margin-top: 0rem;
  width: 100%;
  @media (min-width: 1080px) {
    flex-direction: row;
    padding: 3rem 1rem 1.5rem;
  }
`;
const SectionTitle = styled.div`
  margin: 0 auto;
  max-width: 39rem;
  padding: 2rem 0.5rem 0;
`;

const About = ({ location: { pathname } }) => {
  return (
    <Layout location={pathname}>
      <Avatar
        defaultImage="/portfolio/avatar.png"
        hoverImage="/portfolio/avatar.hover.png"
      />
      <SEO
        title="About | FYUPANQUIA"
        description="Personal Fullstack Developer Portfolio. I'm a Fullstack developer with emphasis on Back-End and JavaScript specialist"
      />
      <SectionTitle>
        <Title fontSize="1.75rem">Here some of my skills</Title>
      </SectionTitle>
      <SectionTitle>
        <ul>
          <ol>Experience with data-driven architecture and systems design, <b>RESTful APIs, microservices</b> architecture.</ol>
          <ol>Proficiency utilizing <b>SQL, NoSQL,</b> in-memory and distributed SQL <b>(e.g. PostgreSQL, Redis, MongoDB, DynamoDB, AuroraDB)</b></ol>
          <ol>Experience integrating with <b>3rd party APIs</b>, external frameworks, and libraries.</ol>
          <ol>Strong understanding and implementation of <b>cloud-native</b> architectures (<b>AWS</b> serverless or containers preferred) at scale in production</ol>
          <ol>Demonstrated understanding and implementation of software design principles such as <b>SOLID</b> and DIExperience with <b>(SaaS, PaaS, IaaS)</b>, multi-tenancy application development</ol>
          <ol>Experience working in a <b>Continuous Integration / Continuous Delivery (CICD)</b> model, including Github and CI pipeline automation tools</ol>
          <ol>Proven success working in <b>Agile</b> environments <b>(Scrum, etc.)</b></ol>
        </ul>

      </SectionTitle>
      <Container>
        <Wrapper>
          <PaperComponent>
            {skills.map((data, index) => (
              <Paper
                key={data.id}
                icon={data.icon}
                columnTitle={data.title}
                knowledgeList={data.knowledgeList}
                lastColumn={skills.length === index + 1}
              />
            ))}
          </PaperComponent>
        </Wrapper>
        <Divider />
      </Container>
    </Layout >
  );
};

export default About;
